var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    { staticClass: "font-strict" },
    [
      _vm._t("default", null, {
        slogan: _vm.presentationDetails.slogan,
        emphasized: _vm.presentationDetails.emphasized,
        label: _vm.presentationDetails.label,
        price: _vm.price,
        title: _vm.title,
        benefitsShown: _vm.benefitsShown,
      }),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }